import { render, staticRenderFns } from "./downloadCollectionLetterOrder.vue?vue&type=template&id=39c70446"
import script from "./downloadCollectionLetterOrder.vue?vue&type=script&lang=js"
export * from "./downloadCollectionLetterOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports